import { globalBreak } from "@/styles/break";
import { resBreak } from "@/utils/resBreak";
import { SxProps } from "@mui/material";

export const HelloRetailOverLaySX: SxProps = {
    p: 1,
    borderRadius: 1,
    bgcolor: '#fff',
    position: 'absolute',
    zIndex: 1400,
    left: '4%',
    right: '4%',
    top: resBreak<'top'>({ mobile: '8.8em', tablet:'5.8em', desktop: '6em' }),
}

export const HelloRetailOverLayContentSX: SxProps = {
    p: 2,
    px:0.5,
    pt:4,
    overflow: 'auto',
    height: globalBreak({ mobile: 'calc(100vh - 11em)', desktop: 'calc(100vh - 8em)' }),
}

export const OverLayShadowSX: SxProps = {
    position: 'fixed',
    zIndex: 1399,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    bgcolor: '#00000080',
    opacity: 1,
    WebkitTapHighlightColor: 'transparent',
    transition: 'opacity 225ms cubic-bezier(0.4, 0, 0.2, 1)'
}

export const searchPopupCloseBtnSX: SxProps = {
    position: 'absolute',
    right: globalBreak({ mobile: 0, desktop: '2%' }),
    top: globalBreak({ mobile: 0, desktop: '2%' }),
    p: globalBreak({ mobile: 0.5, desktop: 1 }),
    display: 'flex',
    borderRadius: '50%',
    //border:'1px solid'
}

export const plpSelectSX: SxProps = {
    width: globalBreak({ mobile: '40px', desktop: '100%' }),
    alignSelf: 'flex-end',
    '& .MuiSelect-select.MuiSelect-outlined.MuiInputBase-input': {
        width: globalBreak({ mobile: '0', desktop: 'inherit' }),
        color: globalBreak({ mobile: '#fff', desktop: '#000' })
    },
    zIndex: 1401
}

export const catNavContainerSX: SxProps = {
    bgcolor: 'inherit',
    py: 1,
    mb: 1,
    '& .hidden': {
        display: 'none'
    },
    flexDirection: 'row',
    columnGap: 2.5,
    maxWidth: '100%',
    overflowX: 'auto',
    flexWrap: 'nowrap'

}

export const categoryButtonsSX: SxProps = {
    px: 2,
    py: 0.8,
    bgcolor: '#000',
    borderRadius: 1,
    color: '#fff',
    whiteSpace: 'nowrap',
    fontFamily: 'mikado-bold',
    fontSize: 16,
    '&:hover':{
        textDecoration:'none'
    }
}


export const categoryTextSX: SxProps = {
    fontSize:'18px !important',
    fontFamily: 'mikado-bold'
}